/**
 * @module store/emails/getters
 *
 * @version 1.0.0
 * @copyright SBC 2019
 */


/**
 * Getter: Возвращает массив e-mails (текущую "страницу")
 *
 * @returns {array}
 */
const emails = state => state.emails;


/**
 * Getter: Возвращает общее число e-mails
 *
 * @returns {number}
 */
const emailsCount = state => state.total;


/**
 * Getter: Возвращает флаг, загружаются ли в текущий момент e-mails
 *
 * @returns {boolean}
 */
const isEmailsLoading = state => state.isLoading;


export default {
  emails,
  emailsCount,
  isEmailsLoading,
};
